export default __webpack_public_path__ + "static/media/wilfred-profile.27e539b4.jpg";